import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { extractRoundScores, getPlayerPoints } from '../utils/utils';
import './LeaderboardRoundScores.css';

const LeaderboardRoundScores = ({ player, fallbackIcon, className = '' }) => {
  const rounds = extractRoundScores(player);
  const items = rounds.length
    ? rounds
    : [
        {
          roundNumber: 0,
          points: getPlayerPoints(player),
          gameTypeIcon: '',
        },
      ];
  const iconFallback = fallbackIcon || IMAGE_CONSTANTS.V2_LEADERBOARD_SCORE_IC;

  return (
    <div className={`lb-round-scores${className ? ` ${className}` : ''}`}>
      {items.map((item) => (
        <span key={`round-${item.roundNumber}`} className="lb-round-scores__item">
          <img
            className="lb-round-scores__ic"
            src={item.gameTypeIcon || iconFallback}
            alt=""
            onError={(event) => {
              const img = event.currentTarget;
              if (img.dataset.fallback === '1') return;
              img.dataset.fallback = '1';
              img.src = iconFallback;
            }}
          />
          <span
            className="lb-round-scores__value"
            style={{ fontFamily: FONTS.INTER_BOLD }}
          >
            {item.points}
          </span>
        </span>
      ))}
    </div>
  );
};

LeaderboardRoundScores.propTypes = {
  player: PropTypes.object,
  fallbackIcon: PropTypes.string,
  className: PropTypes.string,
};

export default LeaderboardRoundScores;
